import React, { Component } from "react";
import {Route, Switch, Link} from "react-router-dom";
import RouteSystem from "../routes";

import layoutUnconnectedDashboard from "../pages/unconnected/Layouts/layoutUnconnectedDashboard";
import DashboardSchoolClientInscription from "../pages/unconnected/school_client_inscription";


export default class UnconnectedRoute extends Component{
    render(){
      return <Route>
        <Switch>
          <RouteSystem.AppUnconnectedRoute
            exact
            //path='*'
            path='/unconnected/school_client_inscription/:school_id'
            component={DashboardSchoolClientInscription}
            layout={layoutUnconnectedDashboard}
          />
        </Switch>
      </Route>;
    }
}